module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/redux-act-async/~/core-js/library/modules/_a-function.js
// module id = 2107
// module chunks = 0